import { Component, OnInit } from '@angular/core';
import { LicenceService } from '../licence.service';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from 'src/app/shared/user/user.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-licence-bandgroup',
  templateUrl: './licence-bandgroup.component.html',
  styleUrls: ['./licence-bandgroup.component.scss']
})
export class LicenceBandgroupComponent implements OnInit {

  licenceBandGroupData : any;
  graphicMode : boolean = false;
  activeCountries : any[] = [];
  regionCodes : string[] = [];

  constructor(
    private licenceService: LicenceService,
    private userService:UserService,
    private route: ActivatedRoute,
    public analyticsService: AnalyticsService,
    private router: Router,
    private location: Location
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  ngOnInit() {
    combineLatest(this.route.params, this.route.queryParams)
    .pipe(map(results => ({bandGroup: results[0].bandGroup, query: results[1]})))
    .subscribe(results => {
      if(results.query && results.query.regionCode){
        this.regionCodes=this.regionCodes.concat(results.query.regionCode);
      }else{
        this.regionCodes=this.regionCodes.concat(this.userService.getRegions());
      }
      this.licenceService.getLicencesByBandGroup(this.regionCodes, results.bandGroup)
      .subscribe(data => {
        this.licenceBandGroupData=data;
        if(data && data.licences.length > 0){
          this.activeCountries.push(data.licences[0].countryCode);
        }
      });
    });
    this.route.fragment.subscribe((fragment: string) => {
      if(fragment && fragment=='graphic'){
        this.graphicMode=true;
      }
    });
  }

  toggleActiveMode() {
    // if(this.isGraphicMode()) {
    //   this.graphicMode = false;
    //
    // } else {
    //   this.graphicMode = true;
    // }
    this.graphicMode=!this.graphicMode;
    this.analyticsService.pushEvent('toggleGraphicView');
    if(this.graphicMode){
      this.location.go(this.router.url.split('#')[0] +"#graphic");
    }else{
      this.location.go(this.router.url.split('#')[0]+"#table");
    }
  }

  isGraphicMode() {
    return this.graphicMode;
  }

  isTableMode() {
    return !this.isGraphicMode();
  }

  toggleActiveRows(row : any) {
    let index=this.activeCountries.indexOf(row.countryCode);
    if( index > -1 ) {
      this.activeCountries.splice(index,1);
    }else{
      this.activeCountries.push(row.countryCode);
    }
  }

  isActiveRow(row : any){
    return this.activeCountries.indexOf(row.countryCode) !== -1 ;
  }

  getBandIfExist(bandCode : string, bands: any[]) {
    for (let band of bands) {
      if(band.code == bandCode){
        return band;
      }
    }
    return null;
  }

}
